// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"a6136dd3","626":"70791994","642":"9f94b27e","681":"a16dbc73","939":"4c8342be"}[chunkId] + ".chunk.js";
};